import React from 'react';

//-- UI
import { Select ,Card } from "antd";

//-- utils
import * as formats from './_infos/Formats.js'

//! *** Image Loader ***
interface FormatSelectProps {
    enabled: boolean;
    name: string;
    onSelect: (event) => void;
}

const ImageLoader: React.FC<FormatSelectProps> = ({ enabled ,name ,onSelect }) => {
    const { Option } = Select;

    const formatDetails = name ? formats.imageFormats.get(name) : null;

    return (
        <>
        <Select defaultValue={name} disabled={!enabled} style={{ width: 180 ,marginRight: 20 }}
            onChange={onSelect}
        >
            <Option value="">Default</Option>,
            { formats.outputFormats.map(format => (
                <Option key={format} value={format}>{format}</Option>
            ))}
        </Select>
        {formatDetails && (
        <Card style={{ width: 300 }} >
            <p><strong>Description:</strong> {formatDetails.description}</p>
            <p><strong>Developer:</strong> {formatDetails.developer}</p>
            <p><strong>Extensions:</strong> {formatDetails.extension.join(', ')}</p>
        </Card>
        )}   
        </>
    );
};

export default ImageLoader;